import { CONSTANTS as LIVECHECK_CONSTANTS } from 'wanderu-ducks-live-check';

const {
    ERROR,
    SUCCESS_PRICE_UP,
    SUCCESS_UNAVAILABLE,
} = LIVECHECK_CONSTANTS;

const CANCEL = 'cancel';
const CHECKOUT = 'checkout';
const DEPART_DIRECTION = 'depart';
const IN_PROGRESS = 'in_progress';
const NOT_STARTED = 'not_started';
const RETURN_DIRECTION = 'return';
const TRIP_SUMMARY = 'trip-summary';

export {
    CANCEL,
    CHECKOUT,
    DEPART_DIRECTION,
    ERROR,
    IN_PROGRESS,
    NOT_STARTED,
    RETURN_DIRECTION,
    SUCCESS_PRICE_UP,
    SUCCESS_UNAVAILABLE,
    TRIP_SUMMARY,
};
